import { useQuestionStore } from '../../stores/questionStore'
import { getQuestionName } from '../../services/questionActions'
import { getQuestionType } from '../../services/questionCatalog'

const answerSource = () => ({
  types: useQuestionStore()
    .questions.filter((question) => question.displayType === 'input')
    .map((question) => ({
      label: getQuestionName(question),
      value: question.id,
      questionType: getQuestionType(question)
    })),
  inputs: []
})

export default answerSource
